import React from "react";
import { useParams } from "react-router-dom";
import { Typography, Image, Flex, Col } from "antd";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Spinner from "../Spinner";
import { useSinglePost } from "../../custom-hooks";
import "./SinglePost.less";

const { Title, Text, Paragraph } = Typography;

export default function SinglePost() {
  const { id } = useParams();
  const [post, isLoading] = useSinglePost(id);

  if (isLoading) return <Spinner />;
  if (!post) return <Text>Post not found.</Text>; // Handle missing post

  // Custom renderer for the rich image
  const renderOptions = {
    renderNode: {
      "embedded-entry-block": (node) => {
        const { title, file } = node.data.target.fields.image.fields;
        return (
          <Col align="center">
            <Image src={file.url} alt={title} className="post__image" />
          </Col>
        );
      },
    },
  };

  return (
    <Flex className="post" vertical style={{ padding: "12px 48px" }}>
      <Col align="center">
        <Title level={2}>{post.title}</Title>
        <Text type="secondary">
          By {post.authors.map((author) => author.fields.name).join(" & ")}
          <br />
          {post.publishedDate}
        </Text>
        <Paragraph>{post.shortDescription}</Paragraph>
      </Col>
      <Col align="center">
        <Image
          className="post__image"
          src={post.featuredImage.fields.file.url}
          alt={post.title}
          style={{ paddingBottom: "8px" }}
        />
        <Paragraph>{post.featuredImage.fields.description}</Paragraph>
      </Col>
      <Col className="post__content">
        {documentToReactComponents(post.content, renderOptions)}
      </Col>
    </Flex>
  );
}
